import {HTTP} from "../http";

export default {
    namespaced: true,

    state: {
        loading: false,
        product: null
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },

        set(state, product) {
            state.product = product;
        }
    },

    actions: {
        load({commit}, name) {
            commit('setLoading', true);

            return HTTP.get('/products/name/' + encodeURIComponent(name))
                .then(resp => commit('set', resp.data))
                .then(() => commit('setLoading', false))
                .catch(err => commit('error/set', err.response, { root: true }));
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/product.js